module.exports = __webpack_public_path__ + "static/assets/b5c0d259d78d3d6b7c74e52ccb376a03.png";